import React, { useState } from 'react';
import tinkerbell from '../pages/img/characters/tinkerball-1.jpeg';
import beauty from '../pages/img/characters/beauty.jpeg';
import dragon from '../pages/img/characters/dragon_warrior.jpeg';
import firstp from '../pages/img/characters/first_princess.jpeg';
import littlem from '../pages/img/characters/little_mermaid.jpeg';
import sleeping from '../pages/img/characters/sleeping_beauty.jpeg';

import sultans from '../pages/img/characters/sultans_daughter.jpeg';
import mulan from '../pages/img/characters/mulan.jpeg';
import rapunzel from '../pages/img/characters/rapunzel.jpeg';
import wayfinder from '../pages/img/characters/wayfinder.jpeg';
import snowwhite from '../pages/img/characters/snowwhite.jpeg';
import spanishprincess from '../pages/img/characters/spanish_princess.jpeg';
import iceprincess from '../pages/img/characters/ice_princess.jpeg';
import snowqueen from '../pages/img/characters/snow_queen.jpeg';
import cinderella from '../pages/img/characters/cinderella.jpeg';
import peter from '../pages/img/characters/peter_pan.jpeg';

import superheroes from '../pages/img/characters/superheroes.jpeg';
import mermaids from '../pages/img/characters/mermaids.jpeg';
import specialty from '../pages/img/characters/specialty_chars.jpeg';
import santa from '../pages/img/characters/santa_holiday.jpeg';


import '../app/app.component.css';

export const CharactersPage = () => {
  const [activeItem, setActiveItem] = useState<number | null>(null); // Specify the type for activeItem

  const handleItemClick = (index: number) => { // Explicitly specify the type for the index parameter
    setActiveItem(index === activeItem ? null : index);
  };

  return (
    <main>
      <h1 style={{ textAlign: 'center', marginTop: '50px', display: 'flex', justifyContent: 'center', color: '#496a86', fontFamily: 'cursive', fontSize: '40px' }}>Fairy Tale Characters</h1>
      <div className='character-container'>
        <div className="character-item" onClick={() => handleItemClick(5)}>
          <img src={littlem} alt="Little Mermaid" className="character-image" />
          <div className={`character-text ${activeItem === 5 ? 'active' : ''}`}>Little Mermaid</div>
          <div className={`character-desc ${activeItem === 5 ? 'active' : ''}`}>The Little Mermaid" is a fairy tale written by author Hans Christian Andersen in 1837.</div>
          <div className='character-title'>Little Mermaid</div>
        </div>
        <div className="character-item" onClick={() => handleItemClick(1)}>
          <img src={mulan} alt="Mulan" className="character-image" />
          <div className={`character-text ${activeItem === 1 ? 'active' : ''}`}>Mulan</div>
          <div className={`character-desc ${activeItem === 1 ? 'active' : ''}`}>A true warrior who went in place of her father to defend China.</div>
          <div className='character-title'>Mulan</div>
        </div>
        <div className="character-item" onClick={() => handleItemClick(2)}>
          <img src={rapunzel} alt="Rapunzel" className="character-image" />
          <div className={`character-text ${activeItem === 2 ? 'active' : ''}`}>Rapunzel</div>
          <div className={`character-desc ${activeItem === 2 ? 'active' : ''}`}>"Rapunzel" is a fairy tale in the collection assembled by the Brothers Grimm, and first published in 1812.</div>
          <div className='character-title'>Rapunzel</div>
        </div>
        <div className="character-item" onClick={() => handleItemClick(3)}>
          <img src={wayfinder} alt="Way Finder" className="character-image" />
          <div className={`character-text ${activeItem === 3 ? 'active' : ''}`}>Way Finder</div>
          <div className={`character-desc ${activeItem === 3 ? 'active' : ''}`}>Her path guides her to what's right. Her heart guides her to what's true.</div>
          <div className='character-title'>Way Finder</div>
        </div>
        <div className="character-item" onClick={() => handleItemClick(4)}>
          <img src={snowwhite} alt="Snow White" className="character-image" />
          <div className={`character-text ${activeItem === 4 ? 'active' : ''}`}>Snow White</div>
          <div className={`character-desc ${activeItem === 4 ? 'active' : ''}`}>Snow White can be found among the stories in the Brother's Grimm folk tale from 1857.</div>
          <div className='character-title'>Snow White</div>
        </div>
        <div className="character-item" onClick={() => handleItemClick(5)}>
          <img src={spanishprincess} alt="Spanish Princess" className="character-image" />
          <div className={`character-text ${activeItem === 5 ? 'active' : ''}`}>Spanish Princess</div>
          <div className={`character-desc ${activeItem === 5 ? 'active' : ''}`}>There is always room in her casa for good friends.</div>
          <div className='character-title'>Spanish Princess</div>
        </div>
        <div className="character-item" onClick={() => handleItemClick(2)}>
          <img src={dragon} alt="Dragon Warrior" className="character-image" />
          <div className={`character-text ${activeItem === 2 ? 'active' : ''}`}>Dragon Warrior</div>
          <div className={`character-desc ${activeItem === 2 ? 'active' : ''}`}>She'll stop at nothing to protect her people.</div>
          <div className='character-title'>Dragon Warrior</div>
        </div>
        <div className="character-item" onClick={() => handleItemClick(6)}>
          <img src={iceprincess} alt="Ice Princess" className="character-image" />
          <div className={`character-text ${activeItem === 6 ? 'active' : ''}`}>Ice Princess</div>
          <div className={`character-desc ${activeItem === 6 ? 'active' : ''}`}>This story originated from a tale written by Hans Christian Anderson in 1845 titled 'Ice Queen'.</div>
          <div className='character-title'>Ice Princess</div>
        </div>
        <div className="character-item" onClick={() => handleItemClick(5)}>
          <img src={snowqueen} alt="Snow Queen" className="character-image" />
          <div className={`character-text ${activeItem === 5 ? 'active' : ''}`}>Snow Queen</div>
          <div className={`character-desc ${activeItem === 5 ? 'active' : ''}`}>This story originated from a tale written by Hans Christian Anderson in 1845 titled 'Ice Queen'.</div>
          <div className='character-title'>Snow Queen</div>
        </div>
        <div className="character-item" onClick={() => handleItemClick(6)}>
          <img src={cinderella} alt="Cinderella" className="character-image" />
          <div className={`character-text ${activeItem === 6 ? 'active' : ''}`}>Cinderella</div>
          <div className={`character-desc ${activeItem === 6 ? 'active' : ''}`}>Cinderella is a well known classic from the Charles Perrault folk tale (Grimm's Fairy Tales) in 1697.</div>
          <div className='character-title'>Cinderella</div>
        </div>
        <div className="character-item" onClick={() => handleItemClick(1)}>
          <img src={beauty} alt="Beauty" className="character-image" />
          <div className={`character-text ${activeItem === 1 ? 'active' : ''}`}>Beauty</div>
          <div className={`character-desc ${activeItem === 1 ? 'active' : ''}`}>Beauty and the Beast was written by G-S Bardot de Villeneuve in 1755.</div>
          <div className='character-title'>Beauty</div>
        </div>
        <div className="character-item" onClick={() => handleItemClick(0)}>
          <img src={tinkerbell} alt="Tinkerbell" className="character-image" />
          <div className={`character-text ${activeItem === 0 ? 'active' : ''}`}>Tinkerbell</div>
          <div className={`character-desc ${activeItem === 0 ? 'active' : ''}`}>Tinker Bell is a fictional character from J. M. Barrie's 1904 play Peter Pan and 1911 novelization Peter and Wendy.</div>
          <div className='character-title'>Tinkerbell</div> 
        </div>
        <div className="character-item" onClick={() => handleItemClick(6)}>
          <img src={peter} alt="Peter Pan" className="character-image" />
          <div className={`character-text ${activeItem === 6 ? 'active' : ''}`}>Peter Pan</div>
          <div className={`character-desc ${activeItem === 6 ? 'active' : ''}`}>Peter Pan first appeared as a character in Barrie's Novel, The Little White Bird (1902)</div>
          <div className='character-title'>Peter Pan</div>
        </div>
        <div className="character-item" onClick={() => handleItemClick(6)}>
          <img src={sleeping} alt="Sleeping Beauty" className="character-image" />
          <div className={`character-text ${activeItem === 6 ? 'active' : ''}`}>Sleeping Beauty</div>
          <div className={`character-desc ${activeItem === 6 ? 'active' : ''}`}>From the Charles Perrault folk tale written in 1697, and also Tchaikovsky's 1890 ballet.</div>
          <div className='character-title'>Sleeping Beauty</div>
        </div>
        <div className="character-item" onClick={() => handleItemClick(0)}>
          <img src={sultans} alt="Sultans Daughter" className="character-image" />
          <div className={`character-text ${activeItem === 0 ? 'active' : ''}`}>Sultans Daughter</div>
          <div className={`character-desc ${activeItem === 0 ? 'active' : ''}`}>'One Thousand and One Nights' mentions the wife of Aladdin, the Sultan's daughter, written in 1706.</div>
          <div className='character-title'>Sultans Daughter</div>
        </div>
        <div className="character-item" onClick={() => handleItemClick(4)}>
          <img src={firstp} alt="First Princess" className="character-image" />
          <div className={`character-text ${activeItem === 4 ? 'active' : ''}`}>First Princess</div>
          <div className={`character-desc ${activeItem === 4 ? 'active' : ''}`}>The youngest Princess in the kingdom, always learning and always helping.</div>
          <div className='character-title'>First Princess</div>
        </div>
      </div>
      <h1 style={{ textAlign: 'center', marginTop: '50px', display: 'flex', justifyContent: 'center', color: '#496a86', fontFamily: 'cursive', fontSize: '40px' }}>Specialty Characters</h1>
      <div className='character-container'>
        <div className="character-item" onClick={() => handleItemClick(0)}>
          <img src={superheroes} alt="Superheroes" className="character-image" />
          <div className={`character-text ${activeItem === 0 ? 'active' : ''}`}>Superheroes</div>
          <div className={`character-desc ${activeItem === 0 ? 'active' : ''}`}>We carry all sorts of Heroes to make your party action packed.</div>
          <div className='character-title'>Superheroes</div>
        </div>
        <div className="character-item" onClick={() => handleItemClick(1)}>
          <img src={mermaids} alt="Mermaids" className="character-image" />
          <div className={`character-text ${activeItem === 1 ? 'active' : ''}`}>Mermaids</div>
          <div className={`character-desc ${activeItem === 1 ? 'active' : ''}`}>Seasonal swimming Mermaids swim in for the summer.</div>
          <div className='character-title'>Mermaids</div>
        </div>
        <div className="character-item" onClick={() => handleItemClick(2)}>
          <img src={specialty} alt="Specialty" className="character-image" />
          <div className={`character-text ${activeItem === 2 ? 'active' : ''}`}>Specialty</div>
          <div className={`character-desc ${activeItem === 2 ? 'active' : ''}`}>Looking for something different? We have lots of entertainers.</div>
          <div className='character-title'>Specialty</div>
        </div>
        <div className="character-item" onClick={() => handleItemClick(3)}>
          <img src={santa} alt="Santa & Holiday" className="character-image" />
          <div className={`character-text ${activeItem === 3 ? 'active' : ''}`}>Santa & Holiday</div>
          <div className={`character-desc ${activeItem === 3 ? 'active' : ''}`}>Planning a holiday party - we can help add more magic.</div>
          <div className='character-title'>Santa & Holiday</div>
        </div>
      </div>
    </main>
  );
}

export default CharactersPage;
